
import UserService from "@/services/user.service";
import AdminService from "@/services/admin.service.js";
import moment from "moment";

/**
 * @classdesc Un remboursement sur une inscription
 * @kind class
 * @export
 * @prop {type} prop - Prop desc
 * @class Inscription_Refund
 */
export default class Inscription_Refund {
    id;
    id_inscription;
    id_commande_inscription;
    amount_refundable = 0;
    amount_to_refund = 0;
    amount_after_refund = 0;
    action = "refund_and_delete";
    error = "";
    base_module = "";
    details = "";
    response = null;
    /**
     * Creates an instance of Inscription_Refund.
     * @constructs
     * @kind function
     * @memberof Inscription_Refund
     */
    constructor() { }


    init(inscription, base_module = "") {
        this.id_inscription = inscription.id;
        this.id_commande_inscription = inscription.commande_inscription.id;
        this.base_module = base_module;

        this.setAmountRefundable(inscription);

    }

    setAmountRefundable(inscription) {
        let amount_refundable = 0;
        let amount_details_options = 0;
        let amount_details_code_reduction = 0;
        let amount_details_refunds = 0;
        let amount_details_commande_inscription = 0;


        if (this.action != 'refund_with_gia') {
            inscription.commande_options.forEach((option) => {
                amount_refundable += parseFloat(option.prix);
                amount_details_options += parseFloat(option.prix);
            });
        }

        amount_refundable += parseFloat(inscription.commande_inscription.prix);
        amount_details_commande_inscription += parseFloat(inscription.commande_inscription.prix);
        if (inscription.code_reduction && inscription.code_reduction.valeur != null) {
            amount_refundable += parseFloat(inscription.code_reduction.valeur);
            amount_details_code_reduction += parseFloat(inscription.code_reduction.valeur);
        }
        if (inscription.refunds && inscription.refunds.length > 0) {
            inscription.refunds.forEach((refund) => {
                amount_refundable -= parseFloat(refund.amount_refunded);
                amount_details_refunds -= parseFloat(refund.amount_refunded);
            });
        }

        if (amount_refundable < 0) amount_refundable = 0;
        this.amount_refundable = amount_refundable;
        this.amount_to_refund = amount_refundable;
        if (this.base_module == "MAXIRACE26") {
            this.alter_amount_to_refund_MAXIRACE26();
        }
        if (this.base_module == "ATLANTIC26") {
            this.alter_amount_to_refund_ATLANTIC26();
        }
        if (this.base_module == "VVX27") {
            this.alter_amount_to_refund_VVX27();
        }
        if (this.base_module == "VICH27") {
            this.alter_amount_to_refund_VICH27();
        }
        this.details = "Inscription: " + amount_details_commande_inscription + "€ | Options: " + amount_details_options + "€ | Code de réduction: " + amount_details_code_reduction + "€ | Remboursements: " + amount_details_refunds + "€";
    }

    alter_amount_to_refund_MAXIRACE26() {
        const current_date = moment();

        const deuxieme_palier = moment("2026-05-10");
        const premier_palier = moment("2026-04-19");

        if (current_date.isAfter(deuxieme_palier)) {
            this.amount_to_refund = parseFloat(this.amount_refundable) * 0.5;
            this.amount_to_refund = this.amount_to_refund.toFixed(2);
            return;
        } else if (current_date.isAfter(premier_palier)) {
            this.amount_to_refund = parseFloat(this.amount_refundable) * 0.70;
            this.amount_to_refund = this.amount_to_refund.toFixed(2);
            return;
        }


    }

    alter_amount_to_refund_ATLANTIC26() {
        const current_date = moment();
        const deuxieme_palier = moment("2026-02-07");
        const premier_palier = moment("2026-01-20");
        if (current_date.isAfter(deuxieme_palier)) {
            this.amount_to_refund = parseFloat(this.amount_refundable) * 0.5;
            this.amount_to_refund = this.amount_to_refund.toFixed(2);
            return;
        } else if (current_date.isAfter(premier_palier)) {
            this.amount_to_refund = parseFloat(this.amount_refundable) * 0.70;
            this.amount_to_refund = this.amount_to_refund.toFixed(2);
            return;
        }
    }

    alter_amount_to_refund_VVX27() {
        const current_date = moment();

        const premier_palier = moment("2027-03-26"); // J-40
        const deuxieme_palier = moment("2027-04-15"); // J-20
        const troisieme_palier = moment("2027-04-30"); // J-5

        if (current_date.isAfter(troisieme_palier)) {
            this.amount_to_refund = 0;
            this.amount_to_refund = this.amount_to_refund.toFixed(2);
            return;
        } else if (current_date.isAfter(deuxieme_palier)) {
            this.amount_to_refund = parseFloat(this.amount_refundable) * 0.5;
            this.amount_to_refund = this.amount_to_refund.toFixed(2);
            return;
        } else if (current_date.isAfter(premier_palier)) {
            this.amount_to_refund = parseFloat(this.amount_refundable) * 0.70;
            this.amount_to_refund = this.amount_to_refund.toFixed(2);
            return;
        }
    }

    alter_amount_to_refund_VICH27() {
        const current_date = moment();

        const premier_palier = moment("2027-02-08"); // J-40
        const deuxieme_palier = moment("2027-02-28"); // J-20
        const troisieme_palier = moment("2027-03-15"); // J-5

        if (current_date.isAfter(troisieme_palier)) {
            this.amount_to_refund = 0;
            this.amount_to_refund = this.amount_to_refund.toFixed(2);
            return;
        } else if (current_date.isAfter(deuxieme_palier)) {
            this.amount_to_refund = parseFloat(this.amount_refundable) * 0.5;
            this.amount_to_refund = this.amount_to_refund.toFixed(2);
            return;
        } else if (current_date.isAfter(premier_palier)) {
            this.amount_to_refund = parseFloat(this.amount_refundable) * 0.70;
            this.amount_to_refund = this.amount_to_refund.toFixed(2);
            return;
        }
    }



    updateAmountToRefund() {
        this.amount_after_refund = parseFloat(this.amount_refundable) - parseFloat(this.amount_to_refund);
        this.amount_after_refund = this.amount_after_refund.toFixed(2);
    }

    async proceedToRefund() {
        this.error = "";
        let request = await AdminService.makeRefund(this);
        if (!request) {
            this.error = "Une erreur est survenue lors du remboursement";
            return false;
        }
        if (request.data.error) {
            this.error = request.data.error;
            return false;
        }
        this.response = request.data;
        return request.data;
    }

    async user_refund_with_gia() {
        let request = await UserService.refundWithGIA(this);
        if (!request) {
            this.error = "Une erreur est survenue lors du remboursement";
            return false;
        }
        if (request.data.error) {
            this.error = request.data.error;
            return false;
        }
        return request.data;
    }

    set(data) { }
}